import { BooleanColumn, NumericalColumn, CustomColumn, StringColumn } from 'baseui/data-table';

export const COL_NAMES = {
	entryFee: 'entryFee',
	numberOfRounds: 'numberOfRounds',
	playersPerTable: 'playersPerTable',
	winnersPerTable: 'winnersPerTable',
	maxWinners: 'maxWinners',
	userLevelsSupported: 'userLevelsSupported',
	tournamentDisplayTime: 'tournamentDisplayTime',
	tournamentRegistrationStartTime: 'tournamentRegistrationStartTime',
	tournamentStartTime: 'tournamentStartTime',
	tournamentComingSoonTime: 'tournamentComingSoonTime',
	name: 'name',
	isSpecial: 'isSpecial',
	isActive: 'isActive',
	isQuickTournament: 'isQuickTournament',
	cardFooterMessage: 'cardFooterMessage',
	prizePot: 'prizePot',
	poolDistribution: 'poolDistribution',
	segmentsList: 'segmentsList',
	instruction: 'instruction',
	timeLimitInSecs: 'timeLimitInSecs',
	stt: 'stt',
	rakebackPoints: 'rakebackPoints',
	enableMLMatchMaking: 'enableMLMatchMaking',
	coinEntryFee: 'coinEntryFee',
	coinDistribution: 'coinDistribution'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Entry Fee',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.entryFee]
	}),
	NumericalColumn({
		title: 'Rounds',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.numberOfRounds]
	}),
	BooleanColumn({
		title: 'isActive',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	}),
	BooleanColumn({
		title: 'isSpecial',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isSpecial]
	}),
	CustomColumn({
		title: 'User Levels Supported',
		mapDataToValue: (data: any) => (data[COL_NAMES.userLevelsSupported] || []).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	NumericalColumn({
		title: 'Max Winners',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.maxWinners] || ''
	}),
	NumericalColumn({
		title: 'Winners Per Table',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.winnersPerTable] || ''
	}),
	NumericalColumn({
		title: 'Players Per Table',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.playersPerTable] || ''
	}),
	StringColumn({
		title: 'Name',
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.name] || ''
	}),
	BooleanColumn({
		title: 'isQuickTournament',
		mapDataToValue: (data: any) => data[COL_NAMES.isQuickTournament]
	}),
	BooleanColumn({
		title: 'isMatchMakingEnabled',
		mapDataToValue: (data: any) => data[COL_NAMES.enableMLMatchMaking]
	}),
	StringColumn({
		title: 'Coming Soon Time',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentComingSoonTime] || ''
	}),
	StringColumn({
		title: 'Display Time',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentDisplayTime] || ''
	}),
	StringColumn({
		title: 'Registration Start Time',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentRegistrationStartTime] || ''
	}),
	StringColumn({
		title: 'Tournament Start Time',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentStartTime] || ''
	}),
	StringColumn({
		title: 'Card Footer Message',
		minWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.cardFooterMessage] || ''
	}),
	NumericalColumn({
		title: 'Prize Pot',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.prizePot] || ''
	}),
	StringColumn({
		title: 'Time Limit In Secs',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.timeLimitInSecs] || ''
	}),
	StringColumn({
		title: 'STT',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.stt] || ''
	}),
	StringColumn({
		title: 'Segment List',
		minWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.segmentsList] || ''
	}),
	StringColumn({
		title: 'Instruction',
		minWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.instruction] || ''
	}),
	StringColumn({
		title: 'rakebackPoints',
		minWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.rakebackPoints] || ''
	}),
	CustomColumn({
		title: 'Pool Distribution',
		mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.poolDistribution]),
		renderCell: (params: any) => params.value || ''
	}),
	NumericalColumn({
		title: 'Coin Entry Fee',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.coinEntryFee] || ''
	}),
	CustomColumn({
		title: 'Coin Distribution',
		mapDataToValue: (data: any) => {
			const coinDistribution = data[COL_NAMES.coinDistribution];
			if (!coinDistribution || !Array.isArray(coinDistribution) || coinDistribution.length === 0) {
				return '';
			}
			return JSON.stringify(
				coinDistribution.map((item: any) => ({
					label: item.label || `Rank ${item.rank}`,
					zcoins: item.zcoins
				}))
			);
		},
		renderCell: (params: any) => params.value
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
